/**
 * @file FormConfirmationModal.js
 * @description Confirmation popup window when performing a CRUD action
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2024, NetCyberOps LLC
 */
import React from "react";
import ConfirmDeleteModal from "@modals/ConfirmDeleteModal/ConfirmDeleteModal";

// Plain "message + Cancel/Confirm" prompt: ConfirmDeleteModal without the header, with a primary Confirm.
export default function FormConfirmationModal({
  showConfirmationModal,
  handleCloseConfirmationModal,
  message,
  handleSubmit,
}) {
  return (
    <ConfirmDeleteModal
      showConfirmationModal={showConfirmationModal}
      handleCloseConfirmationModal={handleCloseConfirmationModal}
      message={message}
      handleDelete={() => handleSubmit()}
      title={null}
      confirmLabel="Confirm"
      variant="primary"
    />
  );
}
